import { render } from "./presentations.vue?vue&type=template&id=3cb6989b"
import script from "./presentations.vue?vue&type=script&lang=js"
export * from "./presentations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__